import { render, staticRenderFns } from "./SharingFromMangomolo.vue?vue&type=template&id=021952b7&"
import script from "./SharingFromMangomolo.vue?vue&type=script&lang=js&"
export * from "./SharingFromMangomolo.vue?vue&type=script&lang=js&"
import style0 from "./SharingFromMangomolo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SharingFromMangomolo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports